import { JSONSerializable } from '../../../util/json';
import { Dec } from '../../numeric';

export class RewardWeightUpdateProposal extends JSONSerializable<
  RewardWeightUpdateProposal.Data
> {
  constructor(
    public title: string,
    public description: string,
    public reward_weight: Dec
  ) {
    super();
  }

  public static fromData(
    data: RewardWeightUpdateProposal.Data
  ): RewardWeightUpdateProposal {
    const {
      value: { title, description, reward_weight },
    } = data;
    return new RewardWeightUpdateProposal(
      title,
      description,
      new Dec(reward_weight)
    );
  }

  public toData(): RewardWeightUpdateProposal.Data {
    const { title, description, reward_weight } = this;
    return {
      type: 'treasury/RewardWeightUpdateProposal',
      value: {
        title,
        description,
        reward_weight: reward_weight.toString(),
      },
    };
  }
}

export namespace RewardWeightUpdateProposal {
  export interface Data {
    type: 'treasury/RewardWeightUpdateProposal';
    value: {
      title: string;
      description: string;
      reward_weight: string;
    };
  }
}
